import type { Step } from '../../types/step';
import type { AppData } from '../../../types/app_data';
import { StepCategory } from '../../../types/app_data';

export const VerifyStep: Step = {
  id: 'verify',
  pathname: '/verify',
  canShow: (appData: AppData) => {
    // If we're asking phone number on the partner landing page, we shouldn't show separate phone step.
    return !appData.phoneVerified;
  },
  hasData: () => true,
  hasOwnData: () => true,
  category: () => StepCategory.GarageOnlyAccount,
};
